import api from '../api';

import type { QueryFunction } from '@tanstack/react-query';
import type { MLDCatalogType, CatalogStore } from 'domains/catalog';

export const getCatalog: QueryFunction<MLDCatalogType | CatalogStore> = async () =>
  (await api
    .get('/reseller/catalog/share', { params: { all: 'true', presenter: 'stargate' } })
    .then((resp) => resp.data)) as MLDCatalogType | CatalogStore;
